module.exports = __webpack_public_path__ + "static/media/wx-menu.60f906f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wx-menu.png
// module id = 201
// module chunks = 6